module.exports = __webpack_public_path__ + "img/use_selected.7ea58949.svg";